import { observer } from 'mobx-react'
import moment from 'moment'
import React, { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import FormInput from '../../../../../components/customElements/FormInput'

type CompleteDrawerModelInfoProps = {
  serviceStore: any
  shortType: boolean
  isToGuaranteeType: boolean
  hideWorkDescription?: boolean
}

const CompleteDrawerModelInfo: FC<CompleteDrawerModelInfoProps> = ({
  serviceStore,
  shortType,
  isToGuaranteeType,
  hideWorkDescription,
}) => {
  const intl = useIntl()
  const { serviceInformationAccordionFormStore, currentServiceData } =
    serviceStore

  useEffect(() => {
    if (shortType) {
      serviceInformationAccordionFormStore.resetValidation()
    } else {
      serviceInformationAccordionFormStore.backValidation()
    }
    if (currentServiceData.dateOfVisit) {
      serviceInformationAccordionFormStore.data.dateOfVisit = moment(
        currentServiceData.dateOfVisit,
      ).format('DD.MM.YYYY')
    }
    if (currentServiceData.workDescription) {
      serviceInformationAccordionFormStore.data.workDescription =
        currentServiceData.workDescription
    }
    if (currentServiceData.visitDescription) {
      serviceInformationAccordionFormStore.data.visitDescription =
        currentServiceData.visitDescription
    }

    return () => serviceInformationAccordionFormStore.clear()
  }, [currentServiceData])

  return (
    <>
      {!isToGuaranteeType && (
        <>
          {/* @ts-ignore */}
          <FormInput
            api={serviceInformationAccordionFormStore}
            type='text'
            label={intl.formatMessage({ id: 'Описание работ' })}
            fullWidth
            propName='workDescription'
            placeholder='Описание работ'
            error={
              !shortType &&
              !serviceInformationAccordionFormStore?.data?.workDescription?.trim()
                ?.length
            }
            multiline
            rows={4}
          />
        </>
      )}
      {isToGuaranteeType && !hideWorkDescription && (
        // @ts-ignore
        <FormInput
          api={serviceInformationAccordionFormStore}
          type='text'
          label={intl.formatMessage({ id: 'Описание работ' })} //visitDescription
          fullWidth
          propName='visitDescription'
          placeholder='Описание работ'
          error={
            !shortType &&
            !serviceInformationAccordionFormStore?.data?.visitDescription?.trim()
              ?.length
          }
          multiline
          rows={4}
        />
      )}
    </>
  )
}

export default observer(CompleteDrawerModelInfo)
